export default __webpack_public_path__ + "static/media/hindu.dc770c8b.jpg";